// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"432":"1378fd6f","659":"40e6d488","736":"e97afca6"}[chunkId] + ".chunk.css";
};